"use client";

import { useEffect, useState } from "react";
import { Confeti } from "@/components/Deco";
import { Enlace } from "@/components/Enlace";
import { EVENTO_ACTIVIDAD_AGREGADA, EVENTO_ITINERARIO, guardarItinerario, leerItinerario, recuperarVisita, type ItinerarioItem } from "@/lib/itinerario";
import { EVENTO_ABRIR_VISITA } from "@/components/InsigniaCarrito";
import { usePagoTours } from "@/components/usePagoTours";
import { PlanVisita } from "@/components/PlanVisita";
import { formatoMXN } from "@/lib/dinero";
import { Img } from "@/components/Img";

export function PanelMiVisita({ idioma }: { idioma: "es" | "en" }) {
  const es = idioma === "es";
  const [abierto, setAbierto] = useState(false);
  const [celebrar, setCelebrar] = useState(false);
  const [items, setItems] = useState<ItinerarioItem[]>([]);
  const cargar = () => setItems(leerItinerario());
  useEffect(() => {
    cargar();
    void recuperarVisita().then(cargar);
    const agregado = () => { cargar(); setCelebrar(true); setAbierto(true); };
    const abrir = () => { cargar(); setCelebrar(false); setAbierto(true); };
    window.addEventListener(EVENTO_ABRIR_VISITA, abrir);
    window.addEventListener(EVENTO_ITINERARIO, cargar);
    window.addEventListener(EVENTO_ACTIVIDAD_AGREGADA, agregado);
    return () => { window.removeEventListener(EVENTO_ABRIR_VISITA, abrir); window.removeEventListener(EVENTO_ITINERARIO, cargar); window.removeEventListener(EVENTO_ACTIVIDAD_AGREGADA, agregado); };
  }, []);
  const pago = usePagoTours();

  return <>
    {abierto && <div className="visita-fondo" role="presentation" onClick={() => setAbierto(false)}>
      <aside className="visita-panel" role="dialog" aria-modal="true" aria-labelledby="mi-visita-lateral" onClick={(e) => e.stopPropagation()}>
        <header><div><span>{es ? "TU VISITA" : "YOUR VISIT"}</span><h2 id="mi-visita-lateral">{es ? "Mi visita" : "My visit"}</h2></div><button type="button" onClick={() => setAbierto(false)} aria-label={es ? "Cerrar" : "Close"}>×</button></header>
        {celebrar && <section className="visita-celebracion" role="status"><Confeti n={20} /><Img src="/media/cleto_festeja.webp" alt="" /><div><strong>{es ? "¡Agregado a tu visita!" : "Added to your visit!"}</strong><p>{es ? "Ya está en tu día." : "It's in your day."}</p></div><button type="button" onClick={() => setCelebrar(false)} aria-label={es ? "Ocultar aviso" : "Hide notice"}>×</button></section>}
        {!items.length ? <div className="visita-vacia"><p>{pago.lineas.length ? (es ? "Tienes tours por pagar." : "You have tours to pay for.") : (es ? "Aún no hay nada en tu visita." : "Nothing in your visit yet.")}</p>{pago.lineas.length > 0 && <Enlace className="boton visita-pagar" href={`/${idioma}/carrito`} onClick={() => setAbierto(false)}>{es ? `Pagar · ${formatoMXN(pago.total, idioma)}` : `Pay · ${formatoMXN(pago.total, idioma)}`}</Enlace>}<Enlace className="boton" href={`/${idioma}/tours`} onClick={() => setAbierto(false)}>{es ? "Ver tours" : "See tours"}</Enlace></div> : <>
          <PlanVisita idioma={idioma} items={items} compacto alNavegar={() => setAbierto(false)} />
          <footer><Enlace href={`/${idioma}/itinerario`} onClick={() => setAbierto(false)}>{es ? "Ver mi visita completa" : "See my full visit"}</Enlace><button type="button" onClick={() => { items.forEach((x) => pago.soltar(x.id)); guardarItinerario([]); }}>{es ? "Vaciar" : "Clear"}</button></footer>
        </>}
      </aside>
    </div>}
  </>;
}
